import { render, staticRenderFns } from "./filter-shop.vue?vue&type=template&id=e46b02a6&scoped=true"
import script from "./filter-shop.vue?vue&type=script&lang=js"
export * from "./filter-shop.vue?vue&type=script&lang=js"
import style0 from "./filter-shop.vue?vue&type=style&index=0&id=e46b02a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46b02a6",
  null
  
)

/* custom blocks */
import block0 from "./filter-shop.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports